<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section" id="sect2"><span href="#/OEBPS/toc#sect2" title="Link target outside of Sample">Make-Ahead Breakfast Casserole</span></h1>
<p class="figure"><img alt="" src="OEBPS/images/6-1.jpg" style="height:70vh"/></p>
<p class="RecipebYieldb">Yield: Serves 10–12 | Prep Time: 20 minutes | Cook Time: 50–55 minutes</p>
<p class="extract_r">Turkey is a leaner meat than beef, so if you’re ever looking to make your favorite beef recipe a little lighter, try it with turkey! It’ll fill you up just the same without sacrificing taste.</p>
<p class="ingredients"><strong>INGREDIENTS</strong></p>
<p class="rec">1 pound turkey breakfast sausage links</p>
<p class="rec">1 red bell pepper, cut into 1-inch dice</p>
<p class="rec">1 small onion, finely diced</p>
<p class="rec">1 (8-ounce) package white button mushrooms, sliced</p>
<p class="rec">1 cup spinach</p>
<p class="rec">4 zucchini, thinly sliced</p>
<p class="rec">½ teaspoon kosher salt</p>
<p class="rec">½ teaspoon freshly ground black pepper</p>
<p class="rec">¼ teaspoon garlic powder</p>
<p class="rec">¼ teaspoon red pepper flakes</p>
<p class="rec">1 teaspoon hot sauce</p>
<p class="rec">1½ cups cottage cheese</p>
<p class="rec">1 cup shredded reduced-fat sharp cheddar cheese</p>
<p class="rec">1 cup shredded reduced-fat Parmesan cheese</p>
<p class="rec">6 large eggs, lightly beaten</p>
<p class="directions"><strong>DIRECTIONS</strong></p>
<p class="recpr">1. Preheat the oven to 350°F. Lightly coat a 9 × 13-inch baking dish with cooking spray.</p>
<p class="recpr">2. In a large skillet, add the sausage and sauté until fully cooked, about 5 minutes. Break up into pieces and continue to cook until browned.</p>
<p class="recpr">3. Remove from the pan with a slotted spoon and place on a plate lined with paper towels.</p>
<p class="recpr">4. Add the bell pepper and onion to the same skillet and sauté until tender, about 4 minutes.</p>
<p class="recpr">5. Add the mushrooms and cook for about 4 minutes. Add the spinach, mix, and turn off the heat.</p>
<p class="recpr">6. In a large bowl, combine the zucchini with the salt, black pepper, garlic powder, red pepper flakes, and hot sauce.</p>
<p class="recpr">7. Stir in the cottage cheese, cheddar cheese, and Parmesan cheese.</p>
<p class="recpr">8. Mix in the cooked sausage. Mix in the cooked vegetables, then the eggs.</p>
<p class="recpr">9. Spoon the mixture into the baking dish. Bake for 40 to 45 minutes until set and the cheese has melted. Allow to cool for 5 to 10 minutes before serving.</p>
<p class="notehead"><strong>NOTES</strong></p>
<p class="NotebText">You can make this casserole the day before and refrigerate it to bake later. Remove the casserole from the fridge 30 minutes before baking to warm.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sect2.vue?48b9e55b